import { WebForm } from 'src/modules/webforms/models/webForm';
import AxiosInstance from 'src/shared/services/axios/interceptor';
import { WebFormsSearchFilter } from 'src/modules/webforms/models/webFormsSearchFilter';
import { PagedResult } from '../models/pagedResult';

const controller = 'WebForm';

export const getAllWebForms = (searchFilter: WebFormsSearchFilter) => {
  const endpoint = `${controller}`;
  return AxiosInstance.get<PagedResult<WebForm>>(endpoint, { params: searchFilter });
};
export const getWebFormByName = (formName: string) => {
  const endpoint = `${controller}/${formName}`;
  return AxiosInstance.get<WebForm>(endpoint);
};

export const updateWebForm = (webForm: WebForm) => {
  const endpoint = `${controller}`;
  return AxiosInstance.put<WebForm>(endpoint, webForm);
};
